import React, { useState, useCallback, useContext } from "react";
import styled from "styled-components";
import { Button, SimpleUtility } from "simple-ui-components";
import { useNavigate } from "react-router";

import Menu from "@material-ui/core/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";

import { AuthContext } from "../authContextProvider";
import { SwitchLanguage } from "../shared/switchLanguage";
import { getTranslation } from "../languageProvider";

const UserInfo = React.memo(() => {
  const navigate = useNavigate();
  const { appUser, logoutHandler } = useContext(AuthContext);
  const { ShortNameGenerate } = SimpleUtility;

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = useCallback(
    (event) => setAnchorEl(event.currentTarget),
    []
  );
  const handleClose = useCallback(() => setAnchorEl(null), []);
  const userShortInfo = ShortNameGenerate(appUser.name);
  const profileClickHandler = () => navigate("/profile");

  return (
    <>
      <span aria-controls="userInformation" onClick={handleClick}>
        {appUser.name} <ArrowDropDownIcon />
      </span>
      <PopoverItem
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        width={250}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <li>
          <span className="userNameBig">{userShortInfo}</span>
          <span className="accountName">{appUser.email}</span>
          {appUser.company && (
            <span className="company">{appUser.company.name}</span>
          )}
          {appUser.role && (
            <span className="role" data-translate="0089">
              {Number(appUser.role.code) ===
                Number(process.env.REACT_APP_MANAGER) && getTranslation("0089")}
            </span>
          )}
        </li>
        <li style={{ paddingTop: 20, paddingBottom: 20 }}>
          <SwitchLanguage />
        </li>
        <li>
          <Button
            theme="default"
            type="button"
            clicked={profileClickHandler}
            icon={<PersonOutlinedIcon />}
            className="btn-secondary"
            text={getTranslation("0034")}
            fullWidth
          />
        </li>
        <li>
          <Button
            theme="default"
            type="button"
            clicked={logoutHandler}
            icon={<ExitToAppIcon />}
            className="btn-danger"
            text={getTranslation("0063")}
            fullWidth
          />
        </li>
      </PopoverItem>
    </>
  );
});

export default UserInfo;
export const PopoverItem = styled(Menu)`
  ${(props) => {
    let current = props.theme;
    let border = `1px solid rgba(${current.black}, 0.1)`;
    return `
    .MuiMenu-paper {
      width: ${props.width}px;
      border: ${border};
      padding:${current.gMD} 0;
      overflow:hidden;
      .MuiMenu-list{
        padding: 0!important;
        >li:first-child{
          display:flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .sizeXXL{
            font-size:80px;
            color:rgba(${current.black}, 0.3);
            margin-bottom:${current.gSM};
          }
          .accountName{
            color:rgb(${current.black});
          }
          .userNameBig{
                ${current.fXXL};
                width:70px;
                height:70px;
                border-radius:50%;
                background:rgb(${current.cOne});
                color:rgb(${current.white});
                align-items: center;
                display: flex;
                justify-content:center;
          }
          .company{
            color:rgb(${current.cOne});
          }
          .role{
            ${current.fSM};
            color:rgba(${current.black},0.3);
          }
          >span{
            margin-bottom:${current.gSM};
            width:100%;
            display:flex;
            justify-content: center;
            align-items: center;
          }
        }
        >li{
          padding:${current.gSM} ${current.gLG};
        }
        .profileHolder{
          border-top:${border};
          border-bottom:${border};
        }
      }
    }
  `;
  }}
`;
